var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDobIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.5,
    height: 16.565,
    viewBox: "0 0 16.5 16.565",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dob-icon",
    transform: "translate(-78.75 0.315)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1048",
    "data-name": "Rectangle 1048",
    width: 16,
    height: 16,
    transform: "translate(79)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2177",
    "data-name": "Group 2177",
    transform: "translate(71.43 -10.57)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_908",
    "data-name": "Ellipse 908",
    cx: 1.342,
    cy: 1.342,
    r: 1.342,
    transform: "translate(11.544 15.886)",
    fill: "gray",
    stroke: "#f5fbfc",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_909",
    "data-name": "Ellipse 909",
    cx: 1.342,
    cy: 1.342,
    r: 1.342,
    transform: "translate(16.913 15.886)",
    fill: "gray",
    stroke: "#f5fbfc",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4446",
    "data-name": "Path 4446",
    d: "M15.841,23.027a3.565,3.565,0,0,1-2.772-1.386A.949.949,0,1,1,14.587,20.5a1.568,1.568,0,0,0,2.508,0,.949.949,0,1,1,1.518,1.138A3.563,3.563,0,0,1,15.841,23.027Z",
    transform: "translate(-0.271 -0.487)",
    fill: "gray",
    stroke: "#f5fbfc",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4447",
    "data-name": "Path 4447",
    d: "M16.86,15.348a.95.95,0,0,1-.313-.053,2.745,2.745,0,0,1-1.242-4.361.949.949,0,1,1,1.487,1.181.908.908,0,0,0-.153.917.936.936,0,0,0,.535.472.949.949,0,0,1-.313,1.845Z",
    transform: "translate(-0.362 0)",
    fill: "gray",
    stroke: "#f5fbfc",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4448",
    "data-name": "Path 4448",
    d: "M15.57,26.57a8,8,0,1,1,8-8,8.009,8.009,0,0,1-8,8Zm0-14.1a6.1,6.1,0,1,0,6.1,6.1,6.109,6.109,0,0,0-6.1-6.1Z",
    transform: "translate(0 0)",
    fill: "gray",
    stroke: "#f5fbfc",
    strokeWidth: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDobIcon);
export default __webpack_public_path__ + "static/media/dob-icon.f1a37e1693e8080d6af7972c774e2174.svg";
export { ForwardRef as ReactComponent };